<div class="w-full">
    <form [formGroup]="form">
        <quill-editor formControlName="remark" [modules]="modules" class="w-full pr-4 py-4 custom-editor"
            placeholder="Please insert Well Integrity Remarks" style="height: 500px;"></quill-editor>

        <div class="mt-4">
            <mat-label>Image Attachments</mat-label>
        </div>
        <!-- TODO: Make the upload image -->
        <mat-form-field appearance="fill" class="w-full pr-4">
            <ngx-mat-dropzone class="p-2">
                <input multiple type="file" placeholder="Click/Drag to upload" fileInput
                    formControlName="attachmentFiles" accept="image/*" (change)="onFileChange($event)" />

                <mat-chip-row *ngFor="
                        let item of form.get('existingAttachments')?.value;
                        index as i
                    " (click)="view($event, i, 'existingAttachments')" class="mt-4 p-4 badge ">
                    {{ item?.name }}

                    <button matChipRemove (click)="removeAttachmentTemp($event, i, 'existingAttachments')">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>

                <mat-chip-row *ngFor="
                        let item of form.get('attachmentFiles')?.value;
                        index as i
                    " (click)="view($event, i, 'attachmentFiles')" class="mt-4 p-4 badge ">
                    {{ item?.name }}

                    <button matChipRemove (click)="removeAttachmentTemp($event, i, 'attachmentFiles')">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            </ngx-mat-dropzone>
            <mat-hint>Click/Drag to upload</mat-hint>
            <mat-icon matSuffix color="primary">cloud_upload</mat-icon>
            <mat-error>Invalid file type</mat-error>
        </mat-form-field>

        <div class="flex justify-center mt-4">
            <button class="btn btn-primary mx-1" (click)="save()"
                [disabled]="isFormChange(form.value, tempForm)">Save</button>
        </div>
    </form>
</div>